'use client';
import { useState, useEffect } from 'react';

const H = "Rajdhani, sans-serif";
const B = "'Nunito Sans', sans-serif";

const SERVICES = [
  { name: 'Nettside', status: 'operational', uptime: 99.98 },
  { name: 'Dashboard', status: 'operational', uptime: 99.95 },
  { name: 'API', status: 'operational', uptime: 99.92 },
  { name: 'SMS-tjeneste', status: 'operational', uptime: 99.87 },
  { name: 'E-posttjeneste', status: 'operational', uptime: 99.99 },
];

function generate90DayHistory(uptime: number) {
  return Array.from({ length: 90 }, (_, i) => {
    const rand = Math.random();
    return rand > (1 - uptime / 100) * 3 ? 'operational' : 'outage';
  });
}

export default function StatusInteractive() {
  const [histories, setHistories] = useState<Record<string, string[]>>({});
  const [lastUpdated, setLastUpdated] = useState('');

  useEffect(() => {
    const h: Record<string, string[]> = {};
    SERVICES.forEach(s => { h[s.name] = generate90DayHistory(s.uptime); });
    setHistories(h);
    setLastUpdated(new Date().toLocaleString('nb-NO'));
  }, []);

  const allOperational = SERVICES.every(s => s.status === 'operational');

  return (
    <div style={{ background: '#0A0A0A', minHeight: '100vh', paddingTop: '52px' }}>
      {/* Hero */}
      <div style={{ borderBottom: '1px solid #1A1A1A', padding: '64px 0 48px' }}>
        <div style={{ maxWidth: '900px', margin: '0 auto', padding: '0 24px' }}>
          <p style={{ fontFamily: B, fontWeight: 300, fontSize: '0.7rem', letterSpacing: '0.2em', textTransform: 'uppercase', color: 'rgba(255,255,255,0.3)', marginBottom: '12px' }}>SebNorge</p>
          <h1 style={{ fontFamily: H, fontWeight: 700, fontSize: 'clamp(2rem, 5vw, 3.5rem)', letterSpacing: '0.06em', textTransform: 'uppercase', color: 'white', margin: '0 0 24px' }}>Systemstatus</h1>
          {/* Overall banner */}
          <div style={{ border: `1px solid ${allOperational ? '#22c55e' : '#ef4444'}`, padding: '16px 24px', display: 'flex', alignItems: 'center', gap: '12px' }}>
            <div style={{ width: '10px', height: '10px', borderRadius: '50%', background: allOperational ? '#22c55e' : '#ef4444', flexShrink: 0 }} />
            <span style={{ fontFamily: H, fontWeight: 700, fontSize: '0.9rem', letterSpacing: '0.1em', textTransform: 'uppercase', color: allOperational ? '#22c55e' : '#ef4444' }}>
              {allOperational ? 'Alle systemer operasjonelle' : 'Driftsforstyrrelse oppdaget'}
            </span>
            <span style={{ fontFamily: B, fontWeight: 300, fontSize: '0.75rem', color: 'rgba(255,255,255,0.3)', marginLeft: 'auto' }}>Sist oppdatert: {lastUpdated}</span>
          </div>
        </div>
      </div>

      {/* Services */}
      <div style={{ maxWidth: '900px', margin: '0 auto', padding: '48px 24px' }}>
        <div style={{ border: '1px solid #2A2A2A' }}>
          {SERVICES.map((service, i) => (
            <div key={service.name} style={{ padding: '24px 28px', borderBottom: i < SERVICES.length - 1 ? '1px solid #1A1A1A' : 'none' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px', flexWrap: 'wrap', gap: '12px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                  <span style={{ fontFamily: H, fontWeight: 700, fontSize: '1rem', letterSpacing: '0.05em', textTransform: 'uppercase', color: 'white' }}>{service.name}</span>
                  <span style={{ fontFamily: H, fontWeight: 700, fontSize: '0.6rem', letterSpacing: '0.15em', textTransform: 'uppercase', color: service.status === 'operational' ? '#22c55e' : '#ef4444', border: `1px solid ${service.status === 'operational' ? '#22c55e' : '#ef4444'}`, padding: '3px 8px' }}>
                    {service.status === 'operational' ? 'Operasjonell' : 'Driftsforstyrrelse'}
                  </span>
                </div>
                <span style={{ fontFamily: B, fontWeight: 300, fontSize: '0.75rem', color: 'rgba(255,255,255,0.35)' }}>{service.uptime}% oppetid siste 90 dager</span>
              </div>
              {/* 90-day history bars */}
              <div style={{ display: 'flex', gap: '2px', alignItems: 'flex-end' }}>
                {(histories[service.name] || []).map((day, idx) => (
                  <div key={idx} title={day === 'operational' ? 'Operasjonell' : 'Driftsforstyrrelse'} style={{ flex: 1, height: '28px', background: day === 'operational' ? '#22c55e' : '#ef4444', opacity: 0.8, minWidth: '2px' }} />
                ))}
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '6px' }}>
                <span style={{ fontFamily: B, fontWeight: 300, fontSize: '0.65rem', color: 'rgba(255,255,255,0.25)' }}>90 dager siden</span>
                <span style={{ fontFamily: B, fontWeight: 300, fontSize: '0.65rem', color: 'rgba(255,255,255,0.25)' }}>I dag</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
